import {EventEmitter, Injectable} from "@angular/core";

/**
 * global variable that toggles the debugmode
 */
declare let advisorDebugmode;

/**
 * Service for storing the debug data that should be visible locale and on dev
 */
@Injectable({
  providedIn: 'root',
})
export class DebugService {
  /**
   * holds the debugdata as key/value pairs. Keys are unique
   */
  debugData: {[key: string]: {name: string, data: any}} = {};

  /**
   * Eventemitter when data changes
   */
  onUpdate: EventEmitter<{[key: string]: {name: string, data: any}}> = new EventEmitter<{[key: string]: {name: string, data: any}}>()

  /**
   *
   * @param key
   * @param name
   * @param data
   */
  public addItem(key: string, name: string, data: any): void {
    this.debugData[name] = {name: name, data: data};

    this.onUpdate.emit(this.debugData);
  }

  /**
   * returns all items that are currentyl stored
   */
  public getItems(): {[key: string]: {name: string, data: any}} {
    return this.debugData;
  }

  /**
   * removes an item from the list
   * @param name
   */
  public removeItem(name: string) {
    if(this.debugData[name]) {
      delete this.debugData[name];
      this.onUpdate.emit(this.debugData);
    }
  }

  /**
   * Returns if the debug mode is on or off.
   */
  public isDebugOn(): boolean {
    return window.location.hostname === 'localhost' || (typeof advisorDebugmode === "boolean" && advisorDebugmode === true);
  }
}
